import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

// This should be a secure, randomly generated key stored securely (e.g., in environment variables)
const SECRET_KEY =  'cookieCPDev';

export const cookieUtils = {
  setSecureCookie: (name: string, value: any, options = {}) => {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
    Cookies.set(name, encryptedValue, {
      ...options,
      secure: true, 
      sameSite: 'strict'
    });
  },

  getSecureCookie: (name: string) => {
    const encryptedValue = Cookies.get(name);
    console.log('Encrypted value:', encryptedValue);
    if (encryptedValue) {
      try {
        const decryptedBytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
        const decryptedValue = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
        return decryptedValue;
      } catch (error) {
        console.error('Error decrypting cookie:', error);
        return null;
      }
    }
    return null;
  },

  
  removeSecureCookie: (name: string) => {
    Cookies.remove(name);
  }
};